export const INIT_CONFERENCE = 'events/INIT_CONFERENCE';

/**
 * @return {{type: string}}
 */
export const initConference = () => ({ type: INIT_CONFERENCE });
